var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTempLow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    display: "block",
    className: "vkuiIcon vkuiIcon--24 vkuiIcon--w-24 vkuiIcon--h-24 vkuiIcon--lightbulb_outline_24",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    style: {
      width: 24,
      height: 24
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    id: "lightbulb_outline_24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3.8c-3.406 0-6.2 2.888-6.2 6.546 0 1.894.6 3.048 1.337 3.99.306.39.627.734.967 1.1q.141.15.287.309c.348.378.71.79 1.021 1.255H11.1v-2.054l-1.745-1.33a.9.9 0 1 1 1.09-1.432L12 13.37l1.555-1.185a.9.9 0 0 1 1.09 1.432l-1.745 1.33V17h1.688c.31-.466.673-.877 1.02-1.255l.288-.31c.34-.365.662-.71.967-1.1.737-.94 1.337-2.095 1.337-3.99 0-3.68-2.792-6.545-6.2-6.545m1.99 15h-3.98l.147.617c.066.276.105.436.142.554a1 1 0 0 0 .042.109.3.3 0 0 0 .121.096 1 1 0 0 0 .115.015c.124.009.289.009.572.009h1.702c.283 0 .448 0 .572-.01a1 1 0 0 0 .115-.015.3.3 0 0 0 .121-.095 1 1 0 0 0 .042-.11c.037-.117.076-.277.142-.553zm-.45 1.375h-.002Zm-3.08 0h.002ZM8 18.132c-.236-.384-.549-.75-.933-1.168l-.253-.273a19 19 0 0 1-1.094-1.246c-.94-1.2-1.72-2.734-1.72-5.1C4 5.78 7.517 2 12 2c4.481 0 8 3.753 8 8.345 0 2.366-.78 3.9-1.72 5.1-.358.457-.747.875-1.094 1.246l-.253.273c-.384.417-.697.784-.934 1.168l-.412 1.728a10 10 0 0 1-.17.654 2.1 2.1 0 0 1-.307.632 2.1 2.1 0 0 1-.871.687c-.238.101-.47.137-.686.153-.196.014-.428.014-.676.014h-1.754c-.248 0-.48 0-.676-.014a2.1 2.1 0 0 1-.686-.153 2.1 2.1 0 0 1-.87-.687 2.1 2.1 0 0 1-.308-.632 10 10 0 0 1-.17-.654z",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lightbulb_outline_24",
    style: {
      fill: "currentcolor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempLow);
export default __webpack_public_path__ + "static/media/temp_low.428f301f9352cca999e73d0bceb10731.svg";
export { ForwardRef as ReactComponent };